import { render, staticRenderFns } from "./Vehicle.vue?vue&type=template&id=67320134&lang=pug&"
import script from "./Vehicle.vue?vue&type=script&lang=ts&"
export * from "./Vehicle.vue?vue&type=script&lang=ts&"
import style0 from "./Vehicle.vue?vue&type=style&index=0&id=67320134&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports